// extracted by mini-css-extract-plugin
export default {"cls1":"DEkfchcNfDrJanaD2GkA","cls2":"C1RvSuimkg6Vg72jYUiF DEkfchcNfDrJanaD2GkA"};